export default "__VITE_ASSET__B7sDlVo2__"